import React, { useEffect, useState } from 'react';
import Layout from '../../components/Layout';
import { Graph } from "react-d3-graph";
import { useWallet } from '../../wallet-context';

const InteractionGraph: React.FC = () => {
  const { walletAddress } = useWallet()
  const [data, setData] = useState<any>()
  // graph payload (with minimalist structure)
  useEffect(() => {
    if(walletAddress)
    (async () => {

      const data = await fetch("https://api.studio.thegraph.com/query/12333/engager/28", {
        "headers": {
          "accept": "*/*",
          "accept-language": "en-US,en;q=0.9",
          "cache-control": "no-cache",
          "content-type": "application/json",
          "pragma": "no-cache",
          "sec-ch-ua": "\"Chromium\";v=\"92\", \" Not A;Brand\";v=\"99\", \"Google Chrome\";v=\"92\"",
          "sec-ch-ua-mobile": "?0",
          "sec-fetch-dest": "empty",
          "sec-fetch-mode": "cors",
          "sec-fetch-site": "same-site"
        },
        "referrer": "https://thegraph.com/",
        "referrerPolicy": "strict-origin-when-cross-origin",
        "body": "{\"query\":\"{\\n  interactions {\\n    id\\n    userInteractions {\\n      owner{\\n        address\\n      }\\n      nfts{\\n        id\\n      }\\n    }\\n  }\\n}\\n\",\"variables\":null}",
        "method": "POST",
        "mode": "cors",
        "credentials": "omit"
      }).then(x => x.json());
      const interactions = data.data.interactions
      const nodes = [...new Set(interactions.map((x: any) => x.userInteractions.map((x: any) => x.owner.address)).flatten())].map((x: any) => ({ id: x}))
      const links = interactions.map((x: any) => x.userInteractions.map((x: any) => x.owner.address)).filter((x: any[]) => x.length === 2).map((x: any) => ({
        source: x[0], target: x[1],
        
      }))
      setData({nodes, links})
    })()
  
  }, [walletAddress])

  // the graph configuration, just override the ones you need
  const myConfig = {
    nodeHighlightBehavior: true,
    automaticRearrangeAfterDropNode: false,
    collapsible: false,
    directed: true,
    focusAnimationDuration: 0.75,
    focusZoom: 1,
    freezeAllDragEvents: false,
    height: 400,
    highlightDegree: 1,
    highlightOpacity: 0.2,
    linkHighlightBehavior: true,
    maxZoom: 8,
    minZoom: 0.1,
    panAndZoom: false,
    staticGraph: false,
    staticGraphWithDragAndDrop: false,
    width: 1400,
    d3: {
      alphaTarget: 0.05,
      gravity: -100,
      linkLength: 100,
      linkStrength: 1,
      disableLinkForce: false
    },
    node: {
      color: "lightgreen",
      size: 500,
      highlightStrokeColor: "blue",
      fontColor: "black",
      fontSize: 12,
      fontWeight: "normal",
      highlightColor: "red",
      highlightFontSize: 12,
      highlightFontWeight: "bold",
      highlightStrokeWidth: 1.5,
      mouseCursor: "pointer",
      opacity: 1,
      renderLabel: true,
      strokeColor: "none",
      strokeWidth: 1.5,
      svg: "https://c.stocksy.com/a/pwb200/z9/622531.jpg",
      symbolType: "circle"
    },
    link: {
      color: "#d3d3d3",
      fontColor: "black",
      fontSize: 8,
      fontWeight: "normal",
      highlightColor: "blue",
      highlightFontSize: 8,
      highlightFontWeight: "normal",
      // labelProperty: "label",
      labelProperty: () => (<><button>Test</button></>) as any,
      mouseCursor: "pointer",
      opacity: 1,
      renderLabel: true,
      semanticStrokeWidth: false,
      strokeWidth: 4,
      markerHeight: 6,
      markerWidth: 6,
      strokeDasharray: 0,
      strokeDashoffset: 0,
      strokeLinecap: "butt"
    },
  };

  const onClickNode = function (nodeId: any) {
    console.log(`Clicked node ${nodeId}`);
  };

  const onClickLink = function (source: any, target: any) {
    console.log(`Clicked link between ${source} and ${target}`);
  };

  return (
    <Layout>
      <main>
        <section className='md:container md:mx-auto bg-gray-50'>
          <div className='flex flex-col items-center justify-center text-center p-7'>
            <h1 className='text-2xl md:text-4xl'>Interaction Topology Graph</h1>
          </div>
          <div className="container my-12 mx-auto px-4 md:px-12">
            {data && <Graph
              id="graph-id" // id is mandatory
              data={data}
              config={myConfig}
              onClickNode={onClickNode}
              onClickLink={onClickLink}
            />};
          </div>
        </section>
      </main>
    </Layout>
  );
};

export default InteractionGraph;
